/* PARWIN: header hairline stays while the announcement bar is visible,
   clears once the announcement bar scrolls out of view. */
(function () {
  if (window.__parwinHeader) return; window.__parwinHeader = true;
  var root = document.documentElement;
  function upd() {
    var ab = document.querySelector('.announcement-bar');
    var keepLine;
    if (ab) {
      keepLine = ab.getBoundingClientRect().bottom > 0;   // announcement bar still on screen
    } else {
      keepLine = (window.scrollY || window.pageYOffset || 0) <= 4;  // fallback: only at very top
    }
    root.classList.toggle('pp-scrolled', !keepLine);       // pp-scrolled removes the line
  }
  upd();
  window.addEventListener('scroll', upd, { passive: true });
  window.addEventListener('resize', upd, { passive: true });
})();
